import { render, staticRenderFns } from "./AlterarUsuario.vue?vue&type=template&id=6eaf466e"
import script from "./AlterarUsuario.vue?vue&type=script&lang=ts"
export * from "./AlterarUsuario.vue?vue&type=script&lang=ts"
import style0 from "./AlterarUsuario.vue?vue&type=style&index=0&id=6eaf466e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports